import { useContext } from "react";
import { Localization } from "@bynder/localization";
import { LocalizationContext } from "./localization.js";
import en_US from "./en_US.json.js";
const localizationFallback = new Localization(en_US);
function useTranslate() {
  const localizationContext = useContext(LocalizationContext);
  const localization = process.env.NODE_ENV !== "test" && localizationContext ? localizationContext : localizationFallback;
  return {
    translate: localization.translate
  };
}
export {
  useTranslate
};
//# sourceMappingURL=useTranslate.js.map
